import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, Input,
  NgZone,
  OnDestroy,
  OnInit
} from '@angular/core';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

enum RATING_MODES {
  MODE_EDIT,
  MODE_VIEW
}

/**
 * Generated class for the RatingBarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'rating-bar',
  templateUrl: 'rating-bar.html',
  styleUrls: ['./rating-bar.scss'],
  standalone: false,
  // imports: [
  //   IonicModule,
  //   CommonModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class RatingBarComponent implements OnInit, OnDestroy, AfterViewInit {

  _mode: number = RATING_MODES.MODE_VIEW;

  @Input()
  set ratemode(m: number) {
    //this.log("setting ratemode to **" + m + "**");
    if (m == undefined) {
      //this.log("undefined => setting it to view");
      this._mode = RATING_MODES.MODE_VIEW;
    }
    if (m == 0)
      this._mode = RATING_MODES.MODE_VIEW;
    else if (m == 1)
      this._mode = RATING_MODES.MODE_EDIT;


    if (this._mode == RATING_MODES.MODE_VIEW) {
      this.editActive = false;
      this.size = 35;
    }
    else {
      this.editActive = true;
      this.size = 40;
    }

  }
  get ratemode() {
    return this._mode;
  }

  size: number;
  drop1: string;
  drop2: string;
  drop3: string;
  drop4: string;
  drop5: string;
  minus: string;
  plus: string;
  which: number;

  // transfer object bound to range element in GUI
  ratingValue: number;
  // Model
//  @Input() rating: number;
  rating: number;

  shouldPublish: boolean = true;

  lasttimestamp: any;

  editActive: boolean = true;

  sliderActive: boolean = false;
  private updateTotalExperienceSubscription: any;
  private clearTotalExperienceSubscription: any;

  public creationTime;

  constructor(
    private events: AppEventService,
    private bhutil: BhutilProvider,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
    this.creationTime = Date.now();
    this.lasttimestamp = Date.now();
    this.ratingValue = 0;

    this.sliderActive = false;

    this.which = -1;

    this.rating = 0;

    this.drop1 = "assets/svg/icon_bh_empty.svg";
    this.drop2 = "assets/svg/icon_bh_empty.svg";
    this.drop3 = "assets/svg/icon_bh_empty.svg";
    this.drop4 = "assets/svg/icon_bh_empty.svg";
    this.drop5 = "assets/svg/icon_bh_empty.svg";

    if (this._mode == RATING_MODES.MODE_VIEW) {
      this.editActive = false;
      this.size = 35;
    }
    else {
      this.editActive = true;
      this.size = 40;
    }

    this.minus = "assets/svg/minus.svg";
    this.plus = "assets/svg/plus.svg";

    this.updateTotalExperienceSubscription = (totalexpevent: any) => {
      this.log(" update totalexperience event received: " + JSON.stringify(totalexpevent));

      if (this.rating != totalexpevent.totalexperience) {
        this.log(" update totalexperience: show new rating " + totalexpevent.totalexperience + " iso " + this.rating);
        this.rating = totalexpevent.totalexperience;
        this.showRating(true);
      }
      else {
        this.log(" update totalexperience: rating didn't change: " + this.rating);
        this.showRating(true);
      }

    };
    this.events.subscribe("beer-analysis-my-ratingnotes:update:totalexperience", this.updateTotalExperienceSubscription);
    this.events.subscribe("beer-analysis-my-summary:update:totalexperience", this.updateTotalExperienceSubscription);

    this.clearTotalExperienceSubscription = (totalexpevent: any) => {
      this.log(" clear:totalexperience event received: " + JSON.stringify(totalexpevent));

      if (this.rating != 0) {
        this.rating = 0;
        this.showRating(false);
      }
    };
    this.events.subscribe("clear:totalexperience", this.clearTotalExperienceSubscription);
  }

  private log(s: string) {
    console.log("[rating-bar-" + this.creationTime + "] " + s);
  }

  ngOnInit() {
    this.log("ngOnInit called");
    this.events.subscribe("beer-detail:update:rating-bar", this.updateTotalExperienceSubscription);
  }

  ngOnDestroy() {
    this.log("ngOnDestroy called");
    this.events.unsubscribe("beer-detail:update:rating-bar", this.updateTotalExperienceSubscription);
    this.events.unsubscribe("beer-analysis-my-ratingnotes:update:totalexperience", this.updateTotalExperienceSubscription);
    this.events.unsubscribe("beer-analysis-my-summary:update:totalexperience", this.updateTotalExperienceSubscription);
    this.events.unsubscribe("clear:totalexperience", this.clearTotalExperienceSubscription);
  }

  ngAfterViewInit() {
    this.log("ngAfterViewInit called");
    this.showRating(false);
  }

  onRatingChange(event: any) {
    this.log("onRatingChange(): rating value is now " + event.value);
    this.log("new rating value: " + this.ratingValue);
    if(this.shouldPublish) {
      //this.rating = this.ratingValue;
      this.showRating(true);
    } else {
      this.log(" no publish this time...");
      //this.rating = this.ratingValue;
      this.showRating(true);//TODO: this should be false, but then for some reason it does not work...
      this.shouldPublish = true;
    }
  }

  minusClick() {
    this.log("minus");
    if (this.rating == 0) {
      this.log(" rating - , already at 0");
      return;
    }
    this.rating = this.rating - 1;
    this.log("rating - , rating " + this.rating);
    //draw again
    this.showRating(true);
  }

  plusClick() {
    this.log("plus");

    if (this.rating == 10) {
      this.log("rating +, already at 10");
      return;
    }
    this.rating = this.rating + 1;
    this.log("rating + , rating " + this.rating);
    //draw again
    this.showRating(true);
  }

  oneClick() {
    if (!this.editActive)
      return;
    this.log("one");

    if (this.which == 1) {
      this.rating = 1;
      this.which = -1;
    }
    else {
      this.rating = 2;
      this.which = 1;

    }

    this.showRating(true);

  }

  twoClick() {
    if (!this.editActive)
      return;
    this.log("two");

    if (this.which == 2) {
      this.rating = 3;
      this.which = -1;
    }
    else {
      this.rating = 4;
      this.which = 2;
    }

    this.showRating(true);

  }

  threeClick() {
    if (!this.editActive)
      return;
    this.log("three");

    if (this.which == 3) {
      this.rating = 5;
      this.which = -1;
    }
    else {
      this.rating = 6;
      this.which = 3;
    }

    this.showRating(true);

  }


  fourClick() {
    if (!this.editActive)
      return;
    this.log("four");

    if (this.which == 4) {
      this.rating = 7;
      this.which = -1;
    }
    else {
      this.rating = 8;
      this.which = 4;

    }

    this.showRating(true);

  }


  fiveClick() {
    if (!this.editActive)
      return;
    this.log("five");

    if (this.which == 5) {
      this.rating = 9;
      this.which = -1;
    }
    else {
      this.rating = 10;
      this.which = 5;
    }

    this.showRating(true);

  }

  showRating(shouldPublish: boolean) {
    this.log(" showRating() called with shouldPublish = " + shouldPublish + " and rating = " + this.rating);
    // Set timeout to enforce update in next javascript event loop to avoid "change in same cycle" error message
      if (shouldPublish && this.rating != 0) {
        this.log(" inside showRating() - should publish rating " + this.rating);
        this.ratingValue = this.rating;
        if(this._mode == RATING_MODES.MODE_EDIT) {
          let now = Date.now();
          let diff = now - this.lasttimestamp;
          this.log("value rating: " + this.rating);

          //set the value for 'which'
          if(this.rating % 2 == 1)
            this.which = -1;
          else
              this.which = Math.round(this.rating / 2.0);

          this.log("showRating diff: " + diff);
          if(diff > 100) {
            this.events.publish("analysis:totalexperience", this.rating);
          }
          else {
            // no event publish needed...
          }
          this.lasttimestamp = Date.now();
        }
      }
      else {
        this.shouldPublish = false;
        this.ratingValue = this.rating;

        this.log(" inside showRating() - should NOT publish rating " + this.rating);
      }

      //set slider to value
      //debugger;
      //this.ratingValue = this.rating;
      let qs = "?t=" + Date.now();

      //set all drop to the empty value
      this.drop1 = "assets/svg/icon_bh_empty.svg" + qs;
      this.drop2 = "assets/svg/icon_bh_empty.svg" + qs;
      this.drop3 = "assets/svg/icon_bh_empty.svg" + qs;
      this.drop4 = "assets/svg/icon_bh_empty.svg" + qs;
      this.drop5 = "assets/svg/icon_bh_empty.svg" + qs;

      if (this.rating == 1) {
        this.log(" inside showRating: setting images for rating = 1");
        this.drop1 = "assets/svg/icon_bh_half.svg" + qs;
        this.drop2 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop3 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop4 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop5 = "assets/svg/icon_bh_empty.svg" + qs;
      }
      else if (this.rating == 2) {
        this.log(" inside showRating: setting images for rating = 2");
        this.drop1 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop2 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop3 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop4 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop5 = "assets/svg/icon_bh_empty.svg" + qs;
      }
      else if (this.rating == 3) {
        this.log(" inside showRating: setting images for rating = 3");
        this.drop1 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop2 = "assets/svg/icon_bh_half.svg" + qs;
        this.drop3 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop4 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop5 = "assets/svg/icon_bh_empty.svg" + qs;
      }
      else if (this.rating == 4) {
        this.log(" inside showRating: setting images for rating = 4");
        this.drop1 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop2 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop3 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop4 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop5 = "assets/svg/icon_bh_empty.svg" + qs;
      }
      else if (this.rating == 5) {
        this.log(" inside showRating: setting images for rating = 5");
        this.drop1 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop2 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop3 = "assets/svg/icon_bh_half.svg" + qs;
        this.drop4 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop5 = "assets/svg/icon_bh_empty.svg" + qs;
      }
      else if (this.rating == 6) {
        this.log(" inside showRating: setting images for rating = 6");
        this.drop1 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop2 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop3 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop4 = "assets/svg/icon_bh_empty.svg" + qs;
        this.drop5 = "assets/svg/icon_bh_empty.svg" + qs;
      }
      else if (this.rating == 7) {
        this.log(" inside showRating: setting images for rating = 7");
        this.drop1 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop2 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop3 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop4 = "assets/svg/icon_bh_half.svg" + qs;
        this.drop5 = "assets/svg/icon_bh_empty.svg" + qs;
      }
      else if (this.rating == 8) {
        this.log(" inside showRating: setting images for rating = 8");
        this.drop1 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop2 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop3 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop4 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop5 = "assets/svg/icon_bh_empty.svg" + qs;
      }
      else if (this.rating == 9) {
        this.log(" inside showRating: setting images for rating = 9");
        this.drop1 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop2 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop3 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop4 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop5 = "assets/svg/icon_bh_half.svg" + qs;
      }
      else if (this.rating == 10) {
        this.log(" inside showRating: setting images for rating = 10");
        this.drop1 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop2 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop3 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop4 = "assets/svg/icon_bh_full.svg" + qs;
        this.drop5 = "assets/svg/icon_bh_full.svg" + qs;
      }
      this.log("drops are: " + "".concat(this.drop1,",",this.drop2,",",this.drop3,",",this.drop4,",",this.drop5));
  }

}
